import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './organizationCommentsInitialState';
import { _setComments } from './organizationCommentsActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getOrganizationCommentsForm = createAsyncThunk(
  'stop/getOrganizationCommentsForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const organizationCommentsSlice = createSlice({
  name: 'stop/organizationCommentsForm',
  initialState,
  reducers: {
    setComments: _setComments,
    resetOrganizationCommentsForm: (state) => initialState,
  },
  extraReducers: {
    [getOrganizationCommentsForm.fulfilled]: (state, action) => action.payload,
  },
});

export const { setComments, resetOrganizationCommentsForm } =
  organizationCommentsSlice.actions;

export default organizationCommentsSlice.reducer;
